import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "app/auth/service";

@Component({
	selector: "app-inicio",
	templateUrl: "./inicio.component.html",
	styleUrls: ["./inicio.component.scss"],
})
export class InicioComponent implements OnInit {
	constructor() { }

	ngOnInit(): void { }
}
